var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { MolPresetOccupation, Preset } from 'packages/mol/entities/Preset';
var MolPresets = /** @class */ (function (_super) {
    __extends(MolPresets, _super);
    function MolPresets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contractLengths = [];
        _this.employmentContractTypes = [];
        _this.occupations = [];
        _this.workingHours = [];
        _this.workingShifts = [];
        _this.salaryTypes = [];
        _this.workStarts = [];
        return _this;
    }
    __decorate([
        Type(Preset),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "contractLengths", void 0);
    __decorate([
        Type(Preset),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "employmentContractTypes", void 0);
    __decorate([
        Type(MolPresetOccupation),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "occupations", void 0);
    __decorate([
        Type(Preset),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "workingHours", void 0);
    __decorate([
        Type(Preset),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "workingShifts", void 0);
    __decorate([
        Type(Preset),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "salaryTypes", void 0);
    __decorate([
        Type(Preset),
        __metadata("design:type", Array)
    ], MolPresets.prototype, "workStarts", void 0);
    return MolPresets;
}(Entity));
export { MolPresets };
